<!-- @veltra/icons generated sha256:80ca7f7b0b1f7af5 gen:8 source:src/svg/normal/rotate-right.svg -->
<script setup lang="ts">
defineOptions({ name: 'RotateRight' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="m5.854 1.323 2.353 2.354L5.854 6.03l-.708-.707 1.147-1.146H4.5q-.621 0-1.06.44Q3 5.054 3 5.676v2H2v-2q0-1.036.732-1.768T4.5 3.177h1.793L5.146 2.03zM5 13.677v-6q0-.099.02-.195.018-.097.056-.188.038-.09.093-.173.054-.082.124-.151.07-.07.151-.125.082-.054.173-.092t.188-.057.195-.02h7q.098 0 .195.02t.188.057.173.092.151.125.124.151.093.173.057.188.019.195v6q0 .098-.02.195-.018.096-.056.187t-.092.173-.125.152-.151.124-.173.093-.188.057-.195.019H6q-.098 0-.195-.02-.097-.019-.188-.056-.09-.038-.173-.093-.081-.054-.151-.124t-.124-.152-.093-.173-.057-.187T5 13.677m1 0h7v-6H6z"
    />
  </svg>
</template>
